<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const confettiEnabled = computed({
  get: () => uiSettings.value.confetti_enabled !== false,
  set: value => {
    updateUISettings({ confetti_enabled: value });
    useAlert(
      t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.CONFETTI.UPDATE_SUCCESS')
    );
  },
});
</script>

<template>
  <div class="flex items-center justify-between gap-4 py-2">
    <div>
      <h4 class="text-sm font-medium text-n-slate-12">
        {{ $t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.CONFETTI.TITLE') }}
      </h4>
      <p class="text-xs text-n-slate-10">
        {{ $t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.CONFETTI.NOTE') }}
      </p>
    </div>
    <Switch v-model="confettiEnabled" />
  </div>
</template>
